const getElement = (element) => {
  if (!element) return void 0;
  if (typeof element === "string") {
    if (typeof document === "undefined") return void 0;
    const idElement = document.getElementById(element);
    return idElement ?? document.querySelector(element) ?? void 0;
  }
  return element.$el ?? element;
};
export {
  getElement as g
};
//# sourceMappingURL=getElement-D_JPfLJS.mjs.map
